// This is just an example,
// so you can safely delete all default props below

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  index: {
    operation: '操作手册',
    app_store: '商用授权',
    app_title: 'APP 名称',
    signin: '访问地址：',
    slogan: '宣传语',
    server: '请求地址',
    index_title: '仓库管理平台',
    webtitle: 'GreaterWMS--开源仓库管理系统',
    home: '首页',
    title: 'GreaterWMS',
    title_tip: 'GreaterWMS首页',
    hide_menu: '收起菜单',
    api: 'API文档',
    translate: '更改语言',
    unread: '未读消息',
    login: '登入',
    register: '注册',
    login_tip: '输入你的OPENID和用户名',
    register_tip: '注册成为管理员',
    logout: '退出登入',
    user_login: '用户登入',
    admin_login: '管理员登入',
    return_to_login: '返回登入',
    user_center: '用户中心',
    change_user: '更改用户',
    view_my_openid: '查看我的OPENID',
    your_openid: '你的OPENID',
    contact_list: '最近联系人',
    chat_more: '更多历史消息',
    chat_no_more: '没有更多消息',
    chat_send: '发送',
    previous: '上一页',
    next: '下一页',
    admin_name: '管理员',
    password: '密码',
    confirm_password: '确认密码',
    staff_name: '用户名',
    cancel: '取消',
    close: '关闭',
    submit: '提交',
    download: '下载',
    updatetitle: '升级就绪',
    updatedesc: '版本已经升级准备就绪',
    update: '马上更新',
    chart: '报表',
    current_user: '当前用户'
  },
  menuItem: {
    dashboard: '报表中心',
    inbound: '收货管理',
    outbound: '发货管理',
    stock: '库存管理',
    finance: '财务中心',
    goods: '商品管理',
    baseinfo: '基本设置',
    warehouse: '仓库设置',
    staff: '用户管理',
    driver: '司机管理',
    customerdn: '客户订单',
    supplierasn: '供应商订单',
    uploadcenter: '上传中心',
    downloadcenter: '下载中心',
    cloudwarehouse: '万仓互联'
  },
  contact: '立即沟通',
  sendmessage: '给他发一条消息',
  send: '发送',
  nomoremessage: '没有更多消息',
  loadmore: '加载更多',
  new: '新增',
  newtip: '新增一条数据',
  refresh: '刷新',
  refreshtip: '刷新所有数据',
  edit: '编辑这条数据',
  confirmedit: '确认编辑数据',
  canceledit: '取消编辑数据',
  delete: '删除这条数据',
  deletetip: '此操作不可逆。',
  confirmdelete: '确认删除数据',
  canceldelete: '取消删除数据',
  download: '下载',
  downloadtip: '下载所有数据',
  frombin: '从库位',
  movetobin: '移库',
  putaway: '上架',
  cyclecount: '动态盘点',
  cyclecountrecorder: '盘点记录',
  search: '关键字搜索',
  creater: '创建人',
  createtime: '创建时间',
  updatetime: '更新时间',
  action: '操作',
  previous: '上一页',
  next: '下一页',
  no_data: '没有更多数据',
  submit: '确认',
  cancel: '取消',
  estimate: '预估运费',
  downloadasnlist: '下载列表',
  downloadasndetail: '下载明细',
  downloadasnlisttip: '下载到货通知书列表',
  downloadasndetailtip: '下载到货通知书明细',
  printthisasn: '查看到货通知书',
  confirmdelivery: '确认已经到货',
  finishloading: '确认卸货完成',
  confirmsorted: '确认分拣完成',
  downloaddnlist: '下载列表',
  downloaddndetail: '下载明细',
  downloaddnlisttip: '下载发货单列表',
  downloaddndetailtip: '下载发货单明细',
  release: '匹配订单',
  releaseallorder: '全部生成拣货单',
  releaseorder: '生成拣货单',
  print: '打印拣货单',
  printthisdn: '查看和打印发货单',
  confirmorder: '确认订单',
  confirmpicked: '确认拣货完成',
  dispatch: '装车发货',
  deletebackorder: '删除欠货订单',
  confirminventoryresults: '确认盘点结果',
  baseinfo: {
    company_info: '公司信息',
    supplier: '供应商',
    customer: '客户',
    view_company: {
      company_name: '公司名称',
      company_city: '所在城市',
      company_address: '地址',
      company_contact: '联系方式',
      company_manager: '负责人',
      error1: '请输入公司名称',
      error2: '请输入公司所在城市',
      error3: '请输入公司地址',
      error4: '请输入公司联系人',
      error5: '请输入公司负责人'
    },
    view_supplier: {
      supplier_name: '供应商名称',
      supplier_city: '所在城市',
      supplier_address: '地址',
      supplier_contact: '联系方式',
      supplier_manager: '负责人',
      supplier_level: '供应商等级',
      error1: '请输入供应商名称',
      error2: '请输入供应商所在城市',
      error3: '请输入供应商地址',
      error4: '请输入联系方式',
      error5: '请输入供应商负责人',
      error6: '请输入供应商级别'
    },
    view_customer: {
      customer_name: '客户名称',
      customer_city: '所在城市',
      customer_address: '地址',
      customer_contact: '联系方式',
      customer_manager: '负责人',
      customer_level: '客户等级',
      error1: '请输入客户名称',
      error2: '请输入客户所在城市',
      error3: '请输入客户地址',
      error4: '请输入联系人',
      error5: '请输入客户经理',
      error6: '请输入客户级别'
    }
  },
  dashboards: {
    outbound_statements: '出库报表',
    inbound_statements: '收货报表',
    inbound_and_outbound_statements: '收发货报表',
    total_sales: '总销量',
    category_sales_ranking: '品类销量排名',
    sales_volume_ranking: '销售额排名',
    sales_volumes_ranking: '销售数量排名',
    total_receipts: '总收货量',
    category_receipt_ranking: '品类收货排名',
    receiving_quantity_ranking: '收货数量排名',
    Receiving_amount_ranking: '收货额排名',
    view_tradelist: {
      mode_code: '交易方式',
      bin_name: '库位名称',
      goods_code: '商品编码',
      goods_qty: '现有数量',
      creater: '创建人',
      update_time: '更新时间',
      create_time: '创建时间',
      inbound: '收货',
      outbound: '发货'
    }
  },
  finance: {
    capital: '固定资产',
    freight: '运费管理',
    view_capital: {
      capital_name: '固定资产名称',
      capital_qty: '数量',
      capital_cost: '金额',
      error1: '请输入资产名称',
      error2: '资产数量必须大于0',
      error3: '资产金额必须大于0'
    },
    view_freight: {
      transportation_supplier: '承运商',
      send_city: '始发城市',
      receiver_city: '到货城市',
      weight_fee: '单公斤运费',
      volume_fee: '单立方米运费',
      min_payment: '最小运费',
      error1: '请输入承运商',
      error2: '请输入发送城市',
      error3: '请输入接收城市',
      error4: '单公斤运费用必须大于0',
      error5: '单立方米运费用必须大于0',
      error6: '最小运费必须大于0'
    }
  },
  driver: {
    driver: '司机管理',
    dispatchlist: '提货记录',
    error1: '请输入司机姓名',
    error2: '请输入车牌号',
    error3: '请输入联系人',
    view_driver: {
      driver_name: '司机姓名',
      license_plate: '车牌号',
      contact: '联系方式'
    },
    view_dispatch: {
      driver_name: '司机姓名',
      dn_code: '提货订单号',
      contact: '联系方式'
    }
  },
  upload_center: {
    initializeupload: '初始化上传',
    uploadfiles: '上传文件',
    upload: '上传',
    uploadcustomerfile: '上传客户清单',
    uploadgoodslistfile: '上传商品表格清单',
    uploadsupplierfile: '上传供应商清单',
    downloadgoodstemplate: '下载商品模板',
    downloadcustomertemplate: '下载客户模板',
    downloadsuppliertemplate: '下载供应商模板',
    addupload: '新增上传'
  },
  download_center: {
    createTime: '创建时间',
    reset: '重置',
    start: '开始',
    end: '结束'
  },
  community_mall: {
    communitymall: '社区商城'
  },
  goods: {
    goods_list: '商品列表',
    unit: '商品单位',
    class: '商品类别',
    color: '商品颜色',
    brand: '商品品牌',
    shape: '商品形状',
    specs: '商品规格',
    origin: '商品产地',
    view_goodslist: {
      goods_code: '商品编码',
      goods_desc: '商品描述',
      goods_name: '商品名称',
      goods_supplier: '供应商',
      goods_weight: '商品重量(单位:克)',
      goods_w: '商品长度(单位:毫米)',
      goods_d: '商品宽度(单位:毫米)',
      goods_h: '商品高度(单位:毫米)',
      unit_volume: '最小单位体积',
      goods_unit: '商品单位',
      goods_class: '商品类别',
      goods_brand: '商品品牌',
      goods_color: '商品颜色',
      goods_shape: '商品形状',
      goods_specs: '商品规格',
      goods_origin: '商品产地',
      goods_cost: '商品成本',
      goods_price: '商品价格',
      print_goods_label: '打印商品标签',
      error1: '请输入商品编码',
      error2: '请输入商品描述',
      error3: '请输入商品的供应商',
      error4: '商品重量必须大于0',
      error5: '商品长度必须大于0',
      error6: '商品宽度必须大于0',
      error7: '商品高度必须大于0',
      error8: '请输入商品成本',
      error9: '请输入商品价格'
    },
    view_unit: {
      goods_unit: '商品单位',
      error1: '请输入商品单位'
    },
    view_class: {
      goods_class: '商品类别',
      error1: '请输入商品类别'
    },
    view_color: {
      goods_color: '商品颜色',
      error1: '请输入商品颜色'
    },
    view_brand: {
      goods_brand: '商品品牌',
      error1: '请输入商品品牌'
    },
    view_shape: {
      goods_shape: '商品形状',
      error1: '请输入商品形状'
    },
    view_specs: {
      goods_specs: '商品规格',
      error1: '请输入商品规格'
    },
    view_origin: {
      goods_origin: '商品产地',
      error1: '请输入商品产地'
    }
  },
  inbound: {
    asn: '到货通知书',
    predeliverystock: '待到货',
    preloadstock: '待卸货',
    presortstock: '待分拣',
    sortstock: '已分拣',
    shortage: '来货短少',
    more: '多到货',
    asnfinish: '收货明细',
    asndone: '收货完成',
    view_sortstock: {
      error1: '请输入数量，数量必须大于0'
    },
    view_asn: {
      asn_code: '到货通知书单号',
      asn_status: '到货通知书状态',
      goods_qty: '到货通知书数量',
      goods_actual_qty: '实际到货数量',
      goods_shortage_qty: '到货短少数量',
      goods_more_qty: '多到货数量',
      goods_damage_qty: '到货破损数量',
      presortstock: '待分拣数量',
      sorted_qty: '已入库数量',
      total_weight: '总重量(单位:千克)',
      total_volume: '总体积(单位:立方米)'
    }
  },
  outbound: {
    dn: '发货单',
    freshorder: '预发货单',
    neworder: '新发货单',
    backorder: '欠货订单',
    pickstock: '待拣货',
    pickedstock: '已拣货',
    pickinglist: '拣货单明细',
    shippedstock: '已发货',
    received: '已签收',
    pod: '签收回单',
    view_dn: {
      dn_code: '发货单号',
      dn_status: '发货单状态',
      goods_qty: '订单数量',
      intransit_qty: '已发货数量',
      delivery_actual_qty: '实际到货数量',
      delivery_shortage_qty: '到货短少',
      delivery_more_qty: '多到货',
      delivery_damage_qty: '到货破损',
      total_weight: '总重量(单位:千克)',
      total_volume: '总体积(单位:立方米)',
      customer: '客户'
    }
  },
  staff: {
    staff: '员工列表',
    check_code: '验证码',
    view_staff: {
      staff_name: '员工名称',
      staff_type: '员工类型',
      error1: '请输入员工姓名',
      error2: '请输入员工类型',
      lock: '锁定',
      unlock: '解锁'
    }
  },
  stock: {
    stocklist: '库存列表',
    stockbinlist: '库位列表',
    emptybin: '空库位',
    occupiedbin: '有货库位',
    view_stocklist: {
      goods_code: '商品编码',
      goods_desc: '商品描述',
      goods_qty: '总数量',
      onhand_stock: '现有数量',
      can_order_stock: '可被下单数量',
      ordered_stock: '已被下单数量',
      inspect_stock: '质检数量',
      hold_stock: '锁货数量',
      damage_stock: '破损数量',
      asn_stock: '到货通知书数量',
      dn_stock: '发货单数量',
      pre_load_stock: '待卸货数量',
      pre_sort_stock: '待分拣数量',
      sorted_stock: '已分拣数量',
      pick_stock: '待拣货数量',
      picked_stock: '已拣货数量',
      back_order_stock: '欠货数量',
      on_hand_inventory: '现有库存',
      history_inventory: '当时库存',
      physical_inventory: '盘点数量',
      difference: '差异',
      cyclecount: '动态盘点',
      recyclecount: '复盘',
      downloadcyclecount: '盘点表',
      cyclecountresult: '确认结果',
      cyclecounttip: '生成动态盘点表',
      recyclecounttip: '生成复盘盘点表',
      downloadcyclecounttip: '下载盘点表',
      cyclecountresulttip: '确认盘点结果',
      daychoice: '日期选择',
      daychoicetip: '选择对应日期的盘点表',
      error1: '计数数量必须大于0',
      dateerror: '选择的日期不正确'
    }
  },
  Settings: {
    index: '设置',
    server: '服务器',
    equipment: '设备支持'
  },
  warehouse: {
    warehouse: '仓库设置',
    binset: '库位设置',
    binsize: '库位尺寸',
    property: '库位属性',
    printbin: '打印库位标签',
    view_warehouseset: {
      error1: '请输入仓库名称',
      error2: '请输入仓库所在城市',
      error3: '请输入仓库地址',
      error4: '请输入仓库联系方式',
      error5: '请输入仓库的负责人'
    },
    view_warehouse: {
      warehouse_name: '仓库名称',
      warehouse_city: '所在城市',
      warehouse_address: '地址',
      warehouse_contact: '联系方式',
      warehouse_manager: '负责人',
      square_measure: '可用面积',
      city_search: '城市搜索',
      publish_warehouse: '发布仓库',
      Nopublish_warehouse: '撤回仓库发布'
    },
    view_binset: {
      bin_name: '库位名称',
      bin_size: '库位尺寸',
      bin_property: '库位属性',
      empty_label: '空库位标识',
      error1: '请输入库位名称',
      error2: '请输入库位尺寸',
      error3: '请输入库位属性'
    },
    view_binsize: {
      bin_size: '库位尺寸',
      bin_size_w: '库位长度(单位:毫米)',
      bin_size_d: '库位宽度(单位:毫米)',
      bin_size_h: '库位高度(单位:毫米)',
      error1: '请输入库位尺寸',
      error2: '库位长度必须大于0',
      error3: '库位宽度必须大于0',
      error4: '库位高度必须大于0'
    },
    view_property: {
      bin_property: '库位属性'
    }
  },
  scan: {
    scan: '扫描',
    scan_asn: 'ASN查询',
    scan_dn: 'DN查询',
    scan_sorting: '分拣',
    scan_uptobin: '上架',
    scan_picking: '拣货',
    scan_shipping: '装车发货',
    scan_movetobin: '移库',
    scan_inventory: '盘点',
    scan_goodsquery: '货物查询',
    scan_locationquery: '库位查询',
    scan_goods_code: '商品编码',
    scan_bin_name: '库位名称',
    scan_goods_label: '商品标签',
    scan_goods_label_error: '商品标签不存在',
    view_binmove: {
      old_bin_name: '原库位名称',
      new_bin_name: '新库位名称',
      qty: '移库数量',
      qty_error: '移库数量不得大于现有数量'
    },
    view_upToBin: {
      goods_actual_qty: '实际到货数量',
      scan_qty: '已扫描数量',
      scan_qty_error: '扫描数量不得大于到货数量'
    },
    view_picking: {
      order_qty: '订单数量',
      picking_qty: '拣货数量',
      picking_qty_error: '拣货数量不得大于订单数量'
    },
    view_shipping: {
      shipping_code: '发货单号',
      driver_info: '司机信息',
      license_plate_number: '车牌号',
      name: '姓名',
      contact_info: '联系方式'
    }
  },
  handcount: {
    handcount: '单项盘点',
    handcountrecorder: '单项盘点记录',
    update_time: '盘点时间'
  },
  notice: {
    valerror: '请输入正确的值',
    unknow_error: '未知错误',
    network_error: '网络异常',
    cyclecounterror: '没有数据',
    userererror: '用户名已存在',
    capitalerror: '固定资产名称已存在',
    valuenullerror: '请填写完整数据',
    loginerror: '请先登录',
    detail: '明细',
    goodserror: {
      goods_listerror: '商品编码已存在',
      goods_uniterror: '商品单位已存在',
      goods_classerror: '商品类别已存在',
      goods_colorerror: '商品颜色已存在',
      goods_branderror: '商品品牌已存在',
      goods_shapeerror: '商品形状已存在',
      goods_specserror: '商品规格已存在',
      goods_originerror: '商品产地已存在'
    },
    baseinfoerror: {
      companyerror: '公司名称已存在',
      customererror: '客户名称已存在',
      suppliererror: '供应商名称已存在'
    },
    warehouseerror: {
      binseterror: '库位名称已存在',
      binsizeerror: '库位尺寸已存在'
    },
    mobile_userlogin: {
      notice1: '请输入您的管理员姓名',
      notice2: '请输入您的管理员密码',
      notice3: '请输入您的员工姓名',
      notice4: '请输入您的员工校验码',
      notice5: '请在设置服务器中输入您的 Openid',
      notice6: '成功登录',
      notice7: '用户或密码不匹配',
      notice8: '员工或检查代码不匹配',
      notice9: '请先登入'
    },
    mobile_scan: {
      notice1: '二维码不存在',
      notice2: '编码不存在',
      notice3: '服务器错误',
      notice4: '只有移动端可以扫描'
    },
    mobile_asn: {
      notice1: '到货通知书列表',
      notice2: '你可以扫描到货通知书的二维码，也可以点击到货通知书，查看到货通知书明细，进行操作',
      notice3: '供应商：',
      notice4: '总金额：',
      notice5: '状态：',
      notice6: '到货通知书明细',
      notice7: '需要扫描到货通知书，来获取到货通知书明细，你可以扫描货物码，或者点击你想要上架的货物，来完成货物上架的操作',
      notice8: '明细',
      notice9: '总金额：',
      notice10: '待上架数量：',
      notice11: '上架数量必须大于0',
      notice12: '上架成功',
      notice13: '请输入库位编码'
    },
    mobile_dn: {
      notice1: '发货单列表',
      notice2: '你可以扫描到发货单的二维码，也可以点击发货单，查看发货单明细，进行操作',
      notice3: '客户：',
      notice4: '总金额：',
      notice5: '状态：',
      notice6: '发货单明细',
      notice7: '发货单明细，是所有的发货单，扫描发货单，可以查看具体发货单的明细',
      notice8: '明细',
      notice9: '总金额：',
      notice10: '发货单数量：',
      notice11: '所有的拣货单明细都在这里，你也可以扫描具体货物，或者发货单，来获取要操作的拣货单',
      notice12: '请输入具体拣货数量',
      notice13: '拣货成功',
      notice14: '库位名称：',
      notice15: '待拣货数量：'
    },
    mobile_goodsstock: {
      notice1: '库存列表',
      notice2: '这里可以看到所有的库存信息，点击可以直接查看库位的库存信息',
      notice3: '在手库存：',
      notice4: '可被下单数量：'
    },
    mobile_binstock: {
      notice1: '库位库存',
      notice2: '这里可以看到所有库位的库存信息，点击可以直接库位的库存，进行移库操作，也可以扫描货物，查看所有的货物存储情况',
      notice3: '库位编码：',
      notice4: '存储数量：',
      notice5: '请输入库位编码',
      notice6: '移库成功'
    },
    mobile_emptybin: {
      notice1: '空库位列表',
      notice2: '这里可以看到所有的空库位',
      notice3: '库位属性：'
    },
    equipment: {
      notice1: '设备支持清单',
      notice2: '这里罗列了所有该APP支持的设备品牌和系统'
    },
    handcount: {
      notice1: '明细',
      notice2: '手动盘点',
      notice3: '现有库存',
      notice4: '盘点数量',
      notice5: '确认结果',
      notice6: '确认盘点结果',
      notice7: '确认盘点成功',
      notice8: '这里显示需要盘点的货物明细'
    },
    400: '错误请求(400)',
    401: '未取得授权(401)',
    403: '拒绝访问(403)',
    404: '资源不存在(404)',
    405: '该功能被禁用(405)',
    408: '请求超时(408)',
    409: '数据冲突(409)',
    410: '数据已删除(410)',
    500: '服务器错误(500)',
    501: '服务未实现(501)',
    502: '网络错误(502)',
    503: '服务不可用(503)',
    504: '网络超时(504)',
    505: 'HTTP版本不受支持(505)'
  }
}
